<template>
  <el-dialog
    v-dialogDrag
    title="选择人员"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    class="mini-dialog"
    append-to-body
  >
    <el-form :model="formData" :rules="formRules" label-width="120px" ref="formRef">
      <el-form-item label="部门">
        <el-select
          v-model="deptValue"
          filterable
          clearable
          placeholder="请选择"
          size="small"
          :loading="deptLoading"
        >
          <el-option
            v-for="item in deptList"
            :key="item.DeptName"
            :label="item.DeptName"
            :value="item.DeptName"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="审核人" prop="uerIds">
        <el-select
          v-model="formData.uerIds"
          multiple
          filterable
          placeholder="请选择"
          size="middle"
          :loading="deptLoading"
        >
          <el-option v-for="item in userList" :key="item.Id" :label="item.Name" :value="item.Id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="text-center">
        <el-button type="primary" size="small" @click="saveBtn" :loading="saveLoading"
          >保存</el-button
        >
        <el-button size="small" @click="cancle">取消</el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import DiyService from '../services/DiyService'

export default {
  name: 'SelectDeptUser',
  props: {
    visible: {
      default: false,
      type: Boolean,
    }, // 是否显示弹窗
    flowName: {
      type: String,
      default: '',
    }, // 流程节点名称
    flowWorkName: {
      type: String,
      default: '承包商人员入厂审批',
    }, // 流程名称
    nodeName: {
      type: String,
      default: '',
    }, // 需要获取人员的节点名称
  },
  watch: {
    deptValue(newValue) {
      this.formData.uerIds = []
      if (!newValue) {
        this.userList = [...this.initUserList]
        return
      }
      this.userList = this.initUserList.filter((item) => {
        return item.DeptName === newValue
      })
    },
  },
  data() {
    return {
      formData: {
        uerIds: [], // 审核人id
      },
      deptValue: '', // 部门
      userList: [], // 审核人列表
      initUserList: [], // 初始化状态下的审核人列表
      deptList: [], // 部门列表
      flowList: [], // 流程列表数据
      formRules: {
        uerIds: [
          {
            required: true,
            message: '请选择审核人',
            trigger: ['blur', 'change'],
          },
          {
            validator: (rule, value, callback) => {
              if (!value || !value.length) {
                callback(new Error('请选择审核人'))
              }
              callback()
            },
          },
        ],
      },
      deptLoading: false, // 部门列表加载loading
      saveLoading: false,
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  methods: {
    // 获取流程
    async getWorkFlowDesign(name) {
      this.deptLoading = true
      const [err, res] = await DiyService.getTableData({
        TableName: 'WF_FlowDesign',
        _PageSize: 15,
        _PageIndex: 1,
        _Where: [{ Name: 'FlowName', Value: name, Type: 'Like' }],
      })
      this.deptLoading = false
      if (!err && res?.Code === 1 && res?.Data && res?.Data?.length) {
        const currentFlowDesign = _.find(res.Data, ['FlowName', this.flowName])
        if (currentFlowDesign) {
          this.workFlowDesignId = currentFlowDesign.Id
        }
      }
    },

    // 获取流程节点
    async getWorkFlowNodes() {
      this.deptLoading = true
      const [err, res] = await DiyService.getTableData({
        TableName: 'WF_Node',
        _SearchEqual: { FlowDesignId: this.workFlowDesignId },
      })
      this.deptLoading = false
      if (!err && res?.Code === 1 && res?.Data && res?.Data?.length) {
        const currentNode = _.find(res.Data, ['NodeName', this.nodeName])
        if (currentNode) {
          this.workFlowNodeId = currentNode.Id
        }
      }
    },

    // 获取用户列表
    async getUserList() {
      this.deptLoading = true
      const [err, res] = await DiyService.getNodeConfirmUsers({
        NodeId: this.workFlowNodeId,
        ApprovalType: 'Agree',
      })
      this.deptLoading = false
      if (!err && res?.Code === 1 && res?.Data && res?.Data?.SelectUsers) {
        this.userList = [...res.Data.SelectUsers]
        this.initUserList = [...res.Data.SelectUsers]
        const deptList = []
        res.Data.SelectUsers.forEach((item) => {
          const dept = deptList.find((deptItem) => {
            return deptItem.DeptName === item.DeptName
          })
          if (!dept && item.DeptId) {
            deptList.push(item)
          }
        })
        this.deptList = [...deptList]
      }
    },

    /**
     * @description 确认选择
     */
    saveBtn() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.$emit('selectSuccess', this.formData.uerIds)
        this.cancle()
      })
    },

    /**
     * @description 取消
     */
    cancle() {
      this.dialogVisible = false
    },
  },

  async created() {
    await this.getWorkFlowDesign(this.flowWorkName)
    await this.getWorkFlowNodes()
    this.getUserList()
  },
}
</script>
<style lang="scss" scoped></style>
